import { isCashierLevel, isCompanyAdmin, isManager } from '@/types';

export function getEffectiveDiscountCap(
  permissions: { max_discount_pct?: number } | undefined,
  companyMaxDiscount: number,
): number {
  if (permissions?.max_discount_pct && permissions.max_discount_pct > 0) {
    return permissions.max_discount_pct;
  }
  return companyMaxDiscount ?? 0;
}

export function getMaxDiscountAmount(subtotal: number, maxDiscountPct: number): number | null {
  if (!maxDiscountPct || maxDiscountPct <= 0) return null;
  return subtotal * maxDiscountPct / 100;
}

export function discountExceedsCap(
  discountAmount: number,
  subtotal: number,
  maxDiscountPct: number,
): boolean {
  const maxAmt = getMaxDiscountAmount(subtotal, maxDiscountPct);
  if (maxAmt === null) return false;
  return discountAmount > maxAmt + 0.01;
}

export function canBypassStaffLimits(role: string): boolean {
  return isCompanyAdmin(role) || isManager(role);
}

export function canEditCartRate(
  role: string,
  permissions: { can_override_min_price?: boolean } | undefined,
): boolean {
  if (!isCashierLevel(role)) return true;
  return !!permissions?.can_override_min_price;
}

export function canAddExpenses(
  role: string,
  permissions: { can_add_expenses?: boolean } | undefined,
): boolean {
  if (isCompanyAdmin(role)) return true;
  return permissions?.can_add_expenses !== false;
}

export function canProcessReturns(
  permissions: { can_process_returns?: boolean } | undefined,
): boolean {
  return permissions?.can_process_returns !== false;
}

export function refundExceedsLimits(
  refundAmount: number,
  permissions: {
    max_refund_amount?: number;
    max_refund_count?: number;
  } | undefined,
  cashierReturnCount: number,
): boolean {
  const maxAmt = permissions?.max_refund_amount ?? 0;
  if (maxAmt > 0 && refundAmount > maxAmt) return true;
  const maxCount = permissions?.max_refund_count ?? 0;
  if (maxCount > 0 && cashierReturnCount >= maxCount) return true;
  return false;
}
